<app-modal-refactor
  [size]="sizeModal || 'lg'"
  [showImage]="!!image"
  [image]="image"
  [isVerPass]=true
  [imageClose]=""
  [showImageClose]=false
>
  <div body class="containerError">
      <div class="left">
        <div class="img-pss">
          <img class="img-zz" [src]="infoClass.imageIcon" alt="" />
        </div>
        <div class="eyebrow">{{ infoClass.subtitle2 }}</div>
        <h2 class="title title-{{fareName}}">{{ infoClass.title }}</h2>

        <ul class="bullets">
          <li *ngFor="let b of infoClass.bullets; let i = index">
            <img class="icon" [src]="infoClass.imgListIcon[i]" alt="icon" />
            <span>{{ b }}</span>
          </li>
        </ul>
      </div>

    <div class="right">
      <div class="close-x" (click)="close()">
        <img [src]="'assets/images/close_m.svg'" alt="close">
      </div>
      <img class="img-fn" [src]="infoClass.imageUrl" alt="" />
    </div>
  </div>
</app-modal-refactor>
